
export const config_kay = {
  "title": "Bridal Customizer",
  "max_view": 3,
    //"view_image_base": "//test.thepersonalizedbest.com/bridal_imageNL/",
    "view_image_base": "//bridalimages.thepersonalizedbest.com/bridal_imageNL/",
    "options_all": [
      "ds","dctw","dq","head","sh",
      "ren",
      "rmet","hmetc","rmetc",
      "rs",
      "er",
      "band",
      "ben",
      "bmet",
      "bmetc",
      //"eb1",
      
      
    ],
    
    "options_ds": {
      "image_base": "shape",
      "name": "Diamond Shape",
      "show": true,
      "option_name": "ds",
      "css": "ds",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "dsr.jpg", 
        "name": "Round",
         "value": "R",
         "effect": [ 
       //  {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": true ,"if_attr": "ud","if_value":["D"]} ,
        ]

      },
        {"image": "dsp.jpg", 
        "name": "Princess", 
        "value": "P",
        "effect": [
        //   {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": true,"if_attr": "ud","if_value":["D"] } ,
       ]

      },
        {
          "image": "dsc.jpg",
          "quality": "",
          "name": "Cushion",
          "value": "C",
          "month": "",
          "effect": [ 
            //{"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": true ,"if_attr": "ud","if_value":["D"]},
         ]
        },
        {
          "image": "dso.jpg",
          "quality": "",
          "name": "Oval",
          "value": "O",
          "month": "",
          "effect": [
           //  {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": false ,"if_attr": "ud","if_value":["D"]},
         ]
        },
      
        {
          "image": "dspr.jpg",
          "quality": "",
          "name": "Pear",
          "value": "PR",
          "month": "",
          "effect": [
           //  {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": false ,"if_attr": "ud","if_value":["D"]},
        
         ]
        }
      ]
    },
    "options_dctw": {
      "image_base": "ctw",
      "name": "Diamond Carat Weight",
      "show": true,
      "option_name": "dctw",
      "type": "control",
      "css": "ctw",
      "image_postfix": "",
      "options": [
     
        {
          "image": "0.33.jpg",
          "name": "1/3 CT.",
          "value": "0.33",
          "effect": [
            // {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true }  ,
        ]
        },
        {
          "image": "0.5.jpg",
          "name": "1/2 CT.",
          "value": "0.5",
          "effect": [
            // {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
           ]
        },
        {
          "image": "0.75.jpg",
          "name": "3/4 CT.",
          "value": "0.75",
          "effect": [ 
            //{"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
        ]
        },
        {
          "image": "1.jpg",
          "name": "1 CT.",
          "value": "1",
          "effect": [
            // {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
        ]
        },
        {
          "image": "1.5.jpg",
          "name": "1 1/2 CT.",
          "value": "1.5",
          "effect": [
//             {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": false } ,
  ]
        }
      ]
    },
    "options_dq": {
      "image_base": "qual6",
      "name": "Diamond Quality",
      "show": true,
      "option_name": "dq",
      "type": "select",
      "css": "dq",
      "image_postfix": "",
      "options": [
        { "image": "good.jpg", "quality": "", "name": "", "value": "I" },
        { "image": "better.jpg", "quality": "", "name": "", "value": "SI" },
        { "image": "best.jpg", "quality": "", "name": "", "value": "VS" }
      ]
    },
    "options_head": {
      "image_base": "heads6",
      "name": "Ring Head",
      "show": true,
      "option_name": "head",
      "type": "control",
      "css":"heads",
      "image_postfix": "ds",
      "options": [
       
        {"image": "n.jpg","quality": "","name": "Classic", "value": "N",
        "effect": [
           {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": false } ,
      ]
        },
        {"image": "s.jpg","quality": "","name": "Halo", "value": "S",
        "effect": [
          {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true } ,
        ]
        },
        {"image": "d.jpg","quality": "","name": "Double Halo", "value": "D",
        "effect": [
          {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true } ,
        
      ]
        }
      ]
    },
    "options_rs": {
      "image_base": "rs",
      "name": "Ring Size",
      "show": true,
      "option_name": "size",
      "type": "select",
      "css":"rs",
      "image_postfix": "",
      "options": [
        {
          "image": "4.jpg",
          "name": "",
          "value": "4"
        },
        {
          "image": "45.jpg",
          "name": "",
          "value": "4.5"
        },
        {
          "image": "5.jpg",
          "name": "",
          "value": "5"
        },
        {
          "image": "55.jpg",
          "name": "",
          "value": "5.5"
        },
        {
          "image": "6.jpg",
          "name": "",
          "value": "6"
        },
        {
          "image": "65.jpg",
          "name": "",
          "value": "6.5"
        },
        {
          "image": "7.jpg",
          "name": "",
          "value": "7"
        },
        {
          "image": "75.jpg",
          "name": "",
          "value": "7.5"
        },
        {
          "image": "8.jpg",
          "name": "",
          "value": "8"
        },
        {
          "image": "85.jpg",
          "name": "",
          "value": "8.5"
        },
        {
          "image": "9.jpg",
          "name": "",
          "value": "9"
        }
      ],
      "attr": "rs"
    },

    "options_rmet": {
      "image_base": "metals6",
      "name": "Metal",
      "show": true,
      "option_name": "rmet",
      "type": "control",
      "css":"line1",
      "image_postfix": "",
      "options": [
       
        {
          "image": "14.jpg",
          "name": "Gold",
          "value": "14",
          "effect": [ 
            {"effect_attr": "show", "optionSet": ["rmetc"],"effect_value": true },
            {"effect_attr": "show", "optionSet": ['hmetc'],"effect_value": true ,"if_attr": "head","if_value":["D","S"]}
          ]
          
        },
        {
          "image": "18.jpg",
          "name": "Gold",
          "value": "18",
          "effect": [ 
            {"effect_attr": "show", "optionSet": ["rmetc"],"effect_value": true },
            {"effect_attr": "show", "optionSet": ['hmetc'],"effect_value": true ,"if_attr": "head","if_value":["D","S"]}
          ]
          
        },
        {
          "image": "PT.jpg",
          "name": "Platinum",
          "value": "PT",
          "effect": [ 
            {"effect_attr": "show", "optionSet": ["rmetc",'hmetc'],"effect_value": false } 
          ]
          
        }
      ]
    },
    "options_bmet": {
      "image_base": "metals6",
      "name": "Band Metal",
      "show": false,
      "option_name": "bmet",
      "css":"line1",
      "type": "control",
      "image_postfix": "",
      "options": [
        
        {
          "image": "14.jpg",
          "name": "Gold",
          "value": "14",
          "effect": [
             {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": true,"if_attr": "band","if_value":["C","S"] } 
          ]
          
        },
        {
          "image": "18.jpg",
          "name": "Gold",
          "value": "18",
          "effect": [ //
            {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": true,"if_attr": "band","if_value":["C","S"] } 
          ]
          
        },
        {
          "image": "PT.jpg",
          "name": "Platinum",
          "value": "PT",
          "effect": [
             {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": false } 
          ]
          
        }
      ]
    },
    "options_hmetc": {
      "image_base": "metalcolors6",
      "name": "Head Color",
      "show": true,
      "css":"line1",
      "option_name": "hmetc",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "W.jpg",
          "name": "White Gold",
          "value": "W"
        },
        {
          "image": "Y.jpg",
          "name": "Yellow Gold",
          "value": "Y"
        },
        {
          "image": "R.jpg",
          "name": "Rose Gold",
          "value": "R"
        }
      ]
    },
    "options_rmetc": {
      "image_base": "metalcolors6",
      "name": "Mounting Color",
      "show": true,
      "css":"line1",
      "option_name": "rmetc",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "W.jpg",
          "name": "White Gold",
          "value": "W"
        },
        {
          "image": "Y.jpg",
          "name": "Yellow Gold",
          "value": "Y"
        },
        {
          "image": "R.jpg",
          "name": "Rose Gold",
          "value": "R"
        }
      ]
    },
    "options_bmetc": {
      "image_base": "metalcolors6",
      "name": "Band Metal Color",
      "show": false,
      "option_name": "bmetc",
      "css":"line1",
      
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "W.jpg",
          "name": "White Gold",
          "value": "W"
        },
        {
          "image": "Y.jpg",
          "name": "Yellow Gold",
          "value": "Y"
        },
        {
          "image": "R.jpg",
          "name": "Rose Gold",
          "value": "R"
        }
      ]
    },
    "options_sh": {
      "image_base": "shank",
      "name": "Mounting",
      "show": true,
      "option_name": "sh",
      "css":"shank",
      "type": "control",
      "image_postfix": "",
      "options": [
        { "image": "STR.jpg","name": "Straight", "value": "STR" ,
        "effect": [
           {"effect_attr": "show", "option": ["C"],"optionSet": ["band"],"effect_value": false} ,
        
      ]
        },
        { "image": "TAP.jpg", "name": "Tapered", "value": "TAP" ,
            "effect": [ 
              {"effect_attr": "show", "option": ["C"],"optionSet": ["band"],"effect_value": false} ,
            
          ]
        },
        {  "image": "SPT.jpg","name": "Split", "value": "SPT" ,
        "effect": [
          {"effect_attr": "show", "option": ["C"],"optionSet": ["band"],"effect_value": true} ,
        
      ]
        },
        {  "image": "TWS.jpg","name": "Twist", "value": "TWS" ,
        "effect": [ 
          {"effect_attr": "show", "option": ["C"],"optionSet": ["band"],"effect_value": true} ,
        
      ]
        },{  "image": "CRS.jpg","name": "Cross-Over", "value": "CRS" ,
        "effect": [ 
          {"effect_attr": "show", "option": ["C"],"optionSet": ["band"],"effect_value": true} ,
        
      ]
        },{  "image": "WOV.jpg","name": "Woven", "value": "WOV" ,
        "effect": [ 
          {"effect_attr": "show", "option": ["C"],"optionSet": ["band"],"effect_value": true} ,
        
      ]
        },
      ]
    },
    
    "options_band": {
      "image_base": "band",
      "name": "Matching Band",
      "show": true,
      "option_name": "band",
      "type": "control",
      "css":"band",
      "image_postfix": "",
      "options": [
        {"image": "none.jpg", "name": "None", "value": "0" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["ben","bmet","bmetc"],"effect_value": false } ]
      },
        {"image": "contour.jpg", "name": "Contour", "value": "C" ,
        "effect": [ 
          {"effect_attr": "show", "optionSet": ["bmet","bmetc"],"effect_value": true },
          {"effect_attr": "show", "optionSet": ["ben"],"effect_value": true}
         ]},
        {"image": "straight.jpg", "name": "Straight", "value": "S" ,
        "effect": [ 
          {"effect_attr": "show", "optionSet": ["bmet","bmetc"],"effect_value": true },
          {"effect_attr": "show", "optionSet": ["ben"],"effect_value": true}
          ]},
        
      ]
    },
    "options_ren": {
      "image_base": "carving6",
      "name": "Finishing",
      "show": true,
      "css":"carv",
      "option_name": "ren",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "1.jpg", "name": "None", "value": "1",
         },
        {"image": "2.jpg", "name": "Milgrain", "value": "2" ,
         },
        {"image": "3.jpg", "name": "Milgrain with Leaf", "value": "3" ,
         },
      ]
    },
    
    "options_ben": {
      "image_base": "carving6",
      "name": "Band Finishing",
      "show": false,
      "css":"carv",
      
      "option_name": "ben",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "1.jpg", "name": "None", "value": "1",
         },
        {"image": "2.jpg", "name": "Milgrain", "value": "2" ,
         },
        {"image": "3.jpg", "name": "Milgrain with Leaf", "value": "3" ,
         },
      ]
    },
    
    "options_er": {
      "show": true,
      "type": "input",
      "options": [
        {
          "attr": "er",
          "show": true,
          "init_text": "Message",
          "switch_view": 2,
          "maxLength": "25",
          "name": ""
        }
      ],
      "name": "Ring Engraving","attr":"er",
    },
    
    
    
  }


// WEBPACK FOOTER //
// ./src/config/kay.js